import { Box } from "@chakra-ui/react";
import BaseModal from "components/Subscription/BaseModal";
import { LoadingBody } from "./PaymentVerification";
import { useTranslation } from "react-i18next";

const IOS = () => {
  const { t } = useTranslation("payment");
  return (
    <Box bg="rgba(0, 0, 0, 0.6)" minH="100vh">
      <BaseModal isOpen={true} onClose={() => {}}>
        <LoadingBody subText={t("redirectingToApp")} />
      </BaseModal>
    </Box>
  );
};

export default IOS;
